import { Navigate, useParams } from "react-router-dom";
import { getSectorBySlug } from "./sectorCatalog";

export default function SectorDiscoverPage() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug || !getSectorBySlug(slug)) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/discover?sector=${encodeURIComponent(slug)}`} replace />;
}
